import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { clearItems } from "../../actions/admin";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

const Sidebar = ({
  users,
  schools,
  assessments,
  dashboard,
  results,
  clearItems,
  classrooms,
  instructions,
}) => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setSelected({
      users: location.pathname.includes("/admin/user"),
      schools: location.pathname.includes("/admin/school"),
      assessments: location.pathname.includes("/admin/assessment"),
      dashboard: location.pathname.includes("/admin/dashboard"),
      results: location.pathname.includes("/admin/result"),
      classrooms: location.pathname.includes("/admin/classroom"),
      instructions: location.pathname.includes("/admin/instructions"),
    });
  }, [location.pathname]);

  const [selected, setSelected] = useState({
    users: location.pathname.includes("/admin/user"),
    schools: location.pathname.includes("/admin/school"),
    assessments: location.pathname.includes("/admin/assessment"),
    dashboard: location.pathname.includes("/admin/dashboard"),
    results: location.pathname.includes("/admin/result"),
    classrooms: location.pathname.includes("/admin/classroom"),
    instructions: location.pathname.includes("/admin/instructions"),
  });
  return (
    <div className=" shadow-lg h-100  sidebar position-fixed bg-white ">
      <div
        className="back"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <div className="sidebar-icon text-center  py-3">
          {!open ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#18a587"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enableBackground="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#18a587"
            >
              <path d="M0,0h24v24H0V0z" fill="none" />
              <path d="M3,18h13v-2H3V18z M3,13h10v-2H3V13z M3,6v2h13V6H3z M21,15.59L17.42,12L21,8.41L19.59,7l-5,5l5,5L21,15.59z" />
            </svg>
          )}
        </div>
      </div>
      {instructions && (
        <div
          className={`d-flex ${
            selected.instructions ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: false,
              schools: false,
              assessments: false,
              dashboard: false,
              results: false,
              classrooms: false,
              instructions: true,
            });
            history.push("/admin/instructions");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              height='24px'
              viewBox='0 0 24 24'
              width='24px'
              fill='#000000'
            >
              <path d='M0 0h24v24H0V0z' fill='none' />
              <path d='M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z' />
            </svg> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              width="24px"
              viewBox="95 80 385 405" /* Tight bounding box around the active path paths */
              preserveAspectRatio="xMidYMid meet"
              version="1.0"
            >
              <path
                fill="#000000" /* Using your app's standard var(--primary) brand color */
                stroke={
                  selected.instructions ? "#18a587" : "#000000"
                } /* Dark contrast boundary border color (e.g., your deep --primary-dark theme) */
                strokeWidth="10" /* Thickness modifier (Increase to 20 or 24 if you want it even thicker) */
                strokeLinejoin="round"
                fillOpacity="1"
                fillRule="evenodd"
                d="M 199.339844 163.648438 L 199.339844 144.589844 C 199.339844 135.328125 191.832031 127.820312 182.574219 127.820312 L 151.664062 127.820312 C 142.402344 127.820312 134.898438 135.328125 134.898438 144.589844 L 134.898438 228.105469 L 103.992188 259.019531 C 99.195312 263.816406 97.761719 271.03125 100.359375 277.296875 C 102.953125 283.5625 109.0625 287.652344 115.847656 287.652344 L 134.898438 287.652344 L 134.898438 461.625 C 134.898438 470.886719 142.402344 478.394531 151.664062 478.394531 C 169.734375 478.394531 212.179688 478.394531 230.25 478.394531 C 234.695312 478.394531 238.960938 476.628906 242.101562 473.484375 C 245.246094 470.339844 247.015625 466.074219 247.015625 461.625 L 247.015625 335.335938 L 325.597656 335.335938 C 325.597656 335.335938 325.597656 461.625 325.597656 461.625 C 325.597656 466.074219 327.363281 470.339844 330.507812 473.484375 C 333.652344 476.628906 337.917969 478.394531 342.363281 478.394531 C 360.433594 478.394531 402.875 478.394531 420.945312 478.394531 C 430.203125 478.394531 437.710938 470.886719 437.710938 461.625 L 437.710938 287.652344 C 443 287.652344 450.078125 287.652344 456.765625 287.652344 C 463.542969 287.652344 469.660156 283.5625 472.253906 277.296875 C 474.847656 271.03125 473.414062 263.816406 468.621094 259.019531 C 429.917969 220.308594 324.332031 114.691406 298.164062 88.515625 C 291.613281 81.96875 280.996094 81.96875 274.449219 88.515625 Z M 342.363281 461.625 L 342.363281 335.335938 C 342.363281 330.886719 340.597656 326.621094 337.449219 323.476562 C 334.308594 320.332031 330.042969 318.5625 325.597656 318.5625 C 307.527344 318.5625 265.085938 318.5625 247.015625 318.5625 C 242.566406 318.5625 238.300781 320.332031 235.15625 323.476562 C 232.011719 326.621094 230.25 330.886719 230.25 335.335938 L 230.25 461.625 C 230.25 461.625 151.664062 461.625 151.664062 461.625 L 151.664062 287.652344 C 151.664062 278.386719 144.160156 270.878906 134.898438 270.878906 L 115.847656 270.878906 C 115.847656 270.878906 286.304688 100.375 286.304688 100.375 L 456.765625 270.878906 C 456.765625 270.878906 437.710938 270.878906 437.710938 270.878906 C 428.453125 270.878906 420.945312 278.386719 420.945312 287.652344 L 420.945312 461.625 Z M 151.664062 211.335938 L 182.574219 180.417969 L 182.574219 144.589844 L 151.664062 144.589844 Z M 151.664062 211.335938"
              />
            </svg>
          </div>
          <div
            className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}
            onClick={() => {
              history.push("/admin/instructions");
              clearItems();
            }}
          >
            Instructions
          </div>
        </div>
      )}
      {dashboard && (
        <div
          className={`d-flex ${
            selected.dashboard ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: false,
              schools: false,
              assessments: false,
              dashboard: true,
              results: false,
              classrooms: false,
              instructions: false,
            });
            history.push("/admin/dashboard");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              height='24px'
              viewBox='0 0 24 24'
              width='24px'
              fill='#000000'
            >
              <path d='M0 0h24v24H0V0z' fill='none' />
              <path d='M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z' />
            </svg> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-bar-chart"
              viewBox="0 0 16 16"
            >
              <path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z" />
            </svg>
          </div>
          <div
            className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}
            onClick={() => {
              history.push("/admin/dashboard");
              clearItems();
            }}
          >
            Dashboard
          </div>
        </div>
      )}
      {schools && (
        <div
          className={`d-flex ${
            selected.schools ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: false,
              schools: true,
              assessments: false,
              dashboard: false,
              results: false,
              classrooms: false,
              instructions: false,
            });
            history.push("/admin/schools");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill={selected.schools ? "#18a587" : "#000000"}
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Schools
          </div>
        </div>
      )}
      {users && (
        <div
          className={`d-flex ${
            selected.users ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: true,
              schools: false,
              assessments: false,
              dashboard: false,
              results: false,
              classrooms: false,
              instructions: false,
            });
            history.push("/admin/users");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              fill="currentColor"
              className="bi bi-people"
              viewBox="0 0 16 16"
            >
              <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
            </svg>
          </div>
          <div className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}>
            Users
          </div>
        </div>
      )}

      {classrooms && (
        <div
          className={`d-flex ${
            selected.classrooms ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: false,
              schools: false,
              assessments: false,
              dashboard: false,
              results: false,
              classrooms: true,
              instructions: false,
            });
            history.push("/admin/classrooms");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              class="bi bi-door-closed"
              viewBox="0 0 16 16"
            >
              <path d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2zm1 13h8V2H4v13z" />
              <path d="M9 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" />
            </svg>
          </div>
          <div
            className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}
            onClick={() => {
              history.push("/admin/classrooms");
              clearItems();
            }}
          >
            Classrooms
          </div>
        </div>
      )}

      {assessments && (
        <div
          className={`d-flex ${
            selected.assessments ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: false,
              schools: false,
              assessments: true,
              dashboard: false,
              results: false,
              classrooms: false,
              instructions: false,
            });
            history.push("/admin/assessments");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              height='24px'
              viewBox='0 0 24 24'
              width='24px'
              fill={selected.assessments ? '#18a587' : '#000000'}
            >
              <path d='M0 0h24v24H0V0z' fill='none' />
              <path d='M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z' />
            </svg> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="145 115 853 629"
              fill={selected.assessments ? "#18a587" : "#232320"}
            >
              <path d="M997.433594 682.835938 C997.414062 702.945312 977.933594 718.429688 961.554688 718.46875 L622.828125 719.125 C592.039062 751.878906 549.253906 751.410156 518.75 718.765625 L192.714844 719.601562 C164.8125 719.675781 145.84375 705.214844 145.871094 676.214844 L146.414062 216.527344 C146.460938 175.480469 199.835938 185.78125 206.210938 181.675781 C214.210938 176.535156 201.339844 129.046875 216.851562 120.152344 C327.367188 103.96875 479.957031 129.027344 571.160156 202.914062 C662.039062 130.8125 801.878906 107.65625 915.226562 118.050781 C924.5 118.898438 933.160156 125.398438 933.324219 134.1875 L934.226562 183.015625 C943.609375 184.480469 951.636719 183.878906 961.269531 183.957031 C981.949219 184.109375 997.910156 199.207031 997.882812 221.269531 L997.425781 682.835938 Z M555.664062 683.890625 L556.007812 227.578125 C471.957031 159.632812 339.269531 138.359375 238.585938 145.351562 L238.84375 612.078125 C363.777344 609.179688 450.566406 624.164062 555.675781 683.902344 Z M905.355469 612.488281 L905.472656 145.703125 C800.160156 137.890625 671.167969 160.828125 585.570312 227.824219 L586.261719 684.546875 C685.046875 622.976562 792.503906 608.808594 905.347656 612.488281 Z" />
              <path d="M862.808594 513.601562 C863.339844 543.5625 768.558594 513.554688 648.007812 579.449219 C640.050781 583.800781 631.691406 576.160156 628.640625 569.824219 C626.160156 564.65625 629.046875 556.160156 638.035156 551.34375 C701.976562 517.070312 772.90625 501.152344 846.433594 500.28125 C856.09375 500.164062 862.667969 505.722656 862.800781 513.601562 Z" />
              <path d="M862.21875 325.429688 C867.578125 356.328125 762.695312 326.046875 647.628906 391.664062 C640.46875 395.75 631.109375 387.265625 628.441406 382.277344 C625.304688 376.425781 629.75 367.664062 638.359375 363.066406 C703.285156 328.355469 775.898438 313.921875 850.082031 313.3125 C857.488281 313.257812 861.535156 321.476562 862.21875 325.429688 Z" />
              <path d="M847.894531 248.539062 C775.539062 250.316406 709.109375 265.035156 647.089844 296.875 C639.480469 300.78125 632.023438 293.625 628.964844 288.695312 C624.839844 282.042969 629.5625 274.632812 638.242188 269.890625 C701.851562 235.152344 772.992188 221.839844 846.070312 220.453125 C855.808594 220.273438 861.953125 224.890625 862.570312 233.050781 C862.988281 238.589844 859.847656 248.246094 847.886719 248.539062 Z" />
              <path d="M850.527344 435.34375 C778.292969 436.230469 711.34375 450.433594 648.921875 485.066406 C639.203125 484.914062 632.582031 483.074219 629.542969 476.203125 C626.105469 468.421875 631.414062 460.980469 640.199219 456.191406 C704.371094 421.195312 776.6875 407.210938 850.59375 407.695312 C858.171875 407.742188 862.933594 416.53125 862.742188 420.664062 C862.5625 424.777344 858.800781 435.25 850.515625 435.355469 Z" />
              <path d="M494.421875 579.277344 C432.476562 546.210938 367.738281 530.808594 298.316406 529.382812 C287.859375 529.164062 280.535156 524.925781 279.613281 518.164062 C277.835938 505.019531 285.996094 500.335938 298.28125 500.382812 C372.003906 500.667969 441.804688 517.660156 505.632812 552.996094 C512.8125 556.976562 514.183594 562.753906 514.25 568.339844 C514.316406 573.738281 504.417969 584.609375 494.421875 579.269531 Z" />
              <path d="M495.136719 391.21875 C432.277344 358.816406 367.996094 343.359375 298.546875 342.40625 C290.480469 342.292969 283.15625 338.789062 280.496094 332.78125 C278.234375 327.699219 279.148438 314.199219 289.65625 313.949219 C366.496094 312.089844 440.894531 329.855469 508.167969 365.46875 C515.320312 369.261719 514.570312 378.667969 513.933594 383.339844 C513.335938 387.789062 503.855469 395.742188 495.125 391.238281 Z" />
              <path d="M490.691406 296.097656 C430.769531 264.542969 366.304688 250.761719 298.089844 249.242188 C287.5 249.003906 280.429688 245.660156 279.480469 236.757812 C278.304688 225.726562 285.246094 220.140625 298.089844 220.292969 C370.011719 221.117188 439.335938 237.367188 502.847656 269.054688 C512.167969 273.710938 517.050781 281.957031 512.945312 290.308594 C509.328125 297.671875 500.398438 301.226562 490.679688 296.105469 Z" />
              <path d="M491.117188 483.328125 C430.066406 450.613281 363.957031 435.34375 294.355469 436.058594 C285.484375 436.152344 279.832031 427.789062 279.832031 421.445312 C279.832031 413.0625 286.710938 406.878906 296.675781 407.039062 C369.324219 408.199219 440.085938 422.308594 503.734375 457.351562 C512.425781 462.128906 515.703125 470.949219 512.226562 478.824219 C509.269531 485.515625 499.761719 487.964844 491.117188 483.339844 Z" />
            </svg>
          </div>
          <div
            className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}
            onClick={() => {
              history.push("/admin/assessments");
              clearItems();
            }}
          >
            {/* Assessments */}
            Library
          </div>
        </div>
      )}

      {results && (
        <div
          className={`d-flex ${
            selected.results ? "sidebar-item-selected" : ""
          } sidebar-row`}
          onClick={() => {
            setSelected({
              users: false,
              schools: false,
              assessments: false,
              dashboard: false,
              results: true,
              classrooms: false,
              instructions: false,
            });
            history.push("/admin/result");
            clearItems();
          }}
        >
          <div className="sidebar-icon text-center  py-2">
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              fill='currentColor'
              class='bi bi-bar-chart'
              viewBox='0 0 16 16'
            >
              <path d='M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z' />
            </svg> */}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill={selected.results ? "#18a587" : "#000000"}
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z" />
            </svg>
          </div>
          <div
            className={`sidebar-description  ${!open ? "d-none" : " py-2"}`}
            onClick={() => {
              history.push("/admin/result");
              clearItems();
            }}
          >
            {/* Results */}
            Assessments
          </div>
        </div>
      )}
    </div>
  );
};

Sidebar.propTypes = {
  clearItems: PropTypes.func.isRequired,
};

export default connect(null, { clearItems })(Sidebar);
